var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-editable-list",
        {
          attrs: {
            columns: _vm.columns,
            "show-select": false,
            "show-actions": false
          }
        },
        [
          _c(
            "template",
            { slot: "data-row" },
            [
              _vm._l(_vm.assessmentDetails, function(detail, idx) {
                return [
                  detail.SCORE !== ""
                    ? _c("table-list-row", {
                        key: "score_" + idx,
                        attrs: {
                          columns: _vm.columns,
                          rowdata: detail,
                          rowIndex: idx,
                          showActions: false
                        }
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "back-link" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          },
          [
            _c("i", {
              staticClass: "fas fa-caret-left",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(
              _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) + "\n\t\t"
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }